
import { defineComponent, PropType } from "vue";

import Player from "@/models/Player";

import PlayerHeader from "@/components/Player/PlayerHeader.vue";
import ActivePlayerArea from "@/components/Player/ActivePlayerArea.vue";
import InactivePlayerArea from "@/components/Player/InactivePlayerArea.vue";

export default defineComponent({
  inject: ["game"],
  components: { PlayerHeader, ActivePlayerArea, InactivePlayerArea },
  props: {
    playerId: { type: Number, required: true },
    position: {
      type: String as PropType<
        "top-left" | "top-right" | "bottom-left" | "bottom-right"
      >,
      required: true,
    },
  },
  computed: {
    player(): Player {
      return this.game.publicState!.players.find(
        ({ id }) => id === this.playerId
      )!;
    },
    isActive(): boolean {
      return this.game.activePlayerId === this.playerId;
    },
    resourcesToDiscard(): number {
      return (
        this.game.publicState?.currentTurn.resourcesToDiscard[this.player.id] ??
        0
      );
    },
  },
});
